import React, { useEffect, useRef } from "react";
import L from "leaflet";

const Map = ({
  loading,
  err,
  data,
  renderData,
}: {
  loading: boolean;
  err: string;
  data: any[];
  renderData: (map: L.Map) => any;
}) => {
  const map = useRef<L.Map | null>(null);

  const BASEMAP = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

  useEffect(() => {
    if (!map.current) {
      let l_map = L.map("map", { dragging: true }).setView([30, 0], 3);
      L.tileLayer(BASEMAP, {
        maxNativeZoom: 99,
        maxZoom: 22,
        attribution: ATTRIBUTION,
      }).addTo(l_map);

      map.current = l_map;
    }
  }, []);

  useEffect(() => {
    // remove old layers
    map.current &&
      map.current.eachLayer((l) => {
        // @ts-ignore
        if (!l._url || l._url !== BASEMAP) {
          map.current && map.current.removeLayer(l);
        }
      });

    // render data
    map.current && renderData(map.current);
  }, [data]);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {/* {loading && <LoadingSpinner />} */}
      {err && (
        <div className="error-container">
          <span className="error-msg">{err}</span>
        </div>
      )}
      <div style={{ height: "100%" }} id="map" />
    </div>
  );
};

export default Map;
